import React from 'react'
import SubmissionsSection from '../submissions/SubmissionsSection'
import { useParams } from 'react-router'
import DashboardSection from '../reports/dashboard-section/DashboardSection'

const TextHomeSection = () => {
    const { layerId: questionId } = useParams()

    return questionId === 'dashboard' ? <DashboardSection /> : <SubmissionsSection />
}

export default TextHomeSection
